module.exports = __webpack_public_path__ + "static/media/project-image-4.98c13356.jpg";